/**
 * "The chat experience" — Widget section (ADR-0074).
 * Reconciled from apps/widget streaming, suggestions, primitives (ActionPlan/
 * ConfirmCard), auth (step-up, act-on-behalf), disclosure, citations, sessions.
 */
import type { DocPageContent } from '../types';

export const WIDGET_CHAT_PAGE: DocPageContent = {
  slug: 'widget/chat',
  titleKey: 'docs.widget.chat.title',
  descriptionKey: 'docs.widget.chat.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.widget.chat.lead' },

    { kind: 'heading', level: 2, id: 'streaming', textKey: 'docs.widget.chat.streaming.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.chat.streaming.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'suggestions',
      textKey: 'docs.widget.chat.suggestions.heading',
    },
    { kind: 'paragraph', textKey: 'docs.widget.chat.suggestions.body' },

    { kind: 'heading', level: 2, id: 'actions', textKey: 'docs.widget.chat.actions.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.chat.actions.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.widget.chat.actions.item.plan',
        'docs.widget.chat.actions.item.confirm',
        'docs.widget.chat.actions.item.result',
      ],
    },

    { kind: 'heading', level: 2, id: 'stepup', textKey: 'docs.widget.chat.stepup.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.chat.stepup.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'disclosures',
      textKey: 'docs.widget.chat.disclosures.heading',
    },
    { kind: 'paragraph', textKey: 'docs.widget.chat.disclosures.body' },

    { kind: 'heading', level: 2, id: 'more', textKey: 'docs.widget.chat.more.heading' },
    {
      kind: 'list',
      itemKeys: ['docs.widget.chat.more.item.citations', 'docs.widget.chat.more.item.history'],
    },

    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.widget.chat.multitab.title',
      textKey: 'docs.widget.chat.multitab.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.widget.chat.next.confirmation.title',
          textKey: 'docs.widget.chat.next.confirmation.text',
          to: { docSlug: 'confirmation' },
        },
        {
          titleKey: 'docs.widget.chat.next.customUi.title',
          textKey: 'docs.widget.chat.next.customUi.text',
          to: { docSlug: 'widget/custom-ui' },
        },
      ],
    },
  ],
};
